<div bookviewerAccessbilityComponent
     [badgeInstruction]="'Drücke Enter um in das Seiten-Menü zu gelangen'"
     (wheel)="stopPropagation($event)"
     [class.active]="!applicationStateService.isSidebarHidden"
     id="bookviewerSidebar">

    <app-user-menu [activeComponent]="sidebarService.activeComponent"></app-user-menu>

    <hr/>
    <!-- https://redmine.sofamedia.at/issues/17777   -->
    <!--    <a *ngIf="showFAQButton"-->
    <!--       class="sidebar-nav-button prominent" [href]="faqURL"-->
    <!--       [url]="'sidebar/sidebar-icon-faq.png' | asset"-->
    <!--       [style.height.px]="'120'"-->
    <!--       [size]="'70%'"-->
    <!--       [position]="'center 15px'"-->
    <!--       target="_blank"-->
    <!--       backgroundImage><span><strong>Erste Hilfe</strong><br/>FAQ</span>-->
    <!--    </a>-->
    <!--    <hr *ngIf="showFAQButton"/>-->
    <button (click)="openComponentInSidebar(SearchComponent)" [class.active]="sidebarService.activeComponent === SearchComponent"
            [position]="'center 15px'"
            [size]="'40%'"
            [style.height.px]="'70'"
            [url]="'sidebar/sidebar-icon-suche.png' | asset"
            backgroundImage
            class="sidebar-nav-button"><span>Suche</span>
    </button>
    <hr/>
    <button (click)="openComponentInSidebar(ChapterContentComponent)" [class.active]="sidebarService.activeComponent === ChapterContentComponent"
            [position]="'center 15px'"
            [size]="'70%'"
            [style.height.px]="'70'"
            [url]="'sidebar/sidebar-icon-kapitel.png' | asset"
            backgroundImage
            class="sidebar-nav-button">
  <span [ngStyle]="{'font-size': '10px'}">
    Favoriten
  </span>
    </button>
    <hr/>
    <button (click)="openComponentInSidebar(PagesContentComponent)" [class.active]="sidebarService.activeComponent === PagesContentComponent"
            [position]="'center 15px'"
            [size]="'70%'"
            [style.height.px]="'70'"
            [url]="'sidebar/sidebar-icon-seiten.png' | asset"
            backgroundImage
            class="sidebar-nav-button"><span>Seiten</span>
    </button>
    <hr/>
    @if (homeworkService.showHomeworkButton || applicationStateService.userData.isTeacher || homeworkService.portfolioLink || (quicklinkService.digiTrainerContent$ | async)) {
        <button
                (click)="openComponentInSidebar(TasksComponent)"
                [class.active]="sidebarService.activeComponent === TasksComponent"
                [position]="'center 15px'"
                [size]="'70%'"
                [style.height.px]="'80'"
                [url]="'sidebar/sidebar-icon-hsm.png' | asset"
                backgroundImage
                class="sidebar-nav-button">
    <span [ngStyle]="applicationStateService.bookConfig.publisherText === 'hoelzel' ? {'font-size': '10px'} : null">
      {{ 'hsm.navbar' | translation: applicationStateService.bookConfig.publisherText }}
    </span>
        </button>
    }
    @if (applicationStateService.bookConfig.exerciseSeries) {
        <hr/>
        <button
                (click)="openComponentInSidebar(DigiTrainerComponent)"
                [class.active]="sidebarService.activeComponent === DigiTrainerComponent"
                [position]="'center 7px'"
                [size]="'50%'"
                [style.height.px]="'80'"
                [url]="'sidebar/sidebar-icon-digitrainer.png' | asset"
                backgroundImage
                class="sidebar-nav-button"><span>digi. <br> trainer</span>
        </button>
    }
    <hr/>
    @if (applicationStateService.userData.isTeacher &&
    applicationStateService.bookConfig.hasTeacherTools &&
           applicationStateService.bookConfig.hasCalcuflowAe) {
        <button
                (click)="openComponentInSidebar(WorksheetsComponent)"
                [class.active]="sidebarService.activeComponent === WorksheetsComponent"
                [position]="'center 15px'"
                [size]="'50%'"
                [style.height.px]="'95'"
                [url]="'sidebar/sidebar-icon-calcuflow.png' | asset"
                backgroundImage
                class="sidebar-nav-button"><span>Arbeits- <br> blatt <br> editor</span>
        </button>
    }
    <hr/>
    @if (applicationStateService.bookConfig.bookPermissions.whiteboard.create &&
    applicationStateService.userData.isTeacher &&
    !applicationStateService.userData.isWhiteboardAuthor &&
    applicationStateService.bookConfig.whiteboard) {
        <button
                (click)="openComponentInSidebar(WhiteboardDrawingContentComponent)"
                [class.active]="sidebarService.activeComponent === WhiteboardDrawingContentComponent"
                [position]="'center 15px'"
                [size]="'70%'"
                [style.height.px]="'80'"
                [url]="'sidebar/sidebar-icon-whiteboard.png' | asset"
                backgroundImage
                class="sidebar-nav-button">
    <span>
      Tafel <br> bilder
    </span>
        </button>
    }
    @if (applicationStateService.bookConfig.bookPermissions.whiteboard.create &&
    applicationStateService.userData.isTeacher &&
    !applicationStateService.userData.isWhiteboardAuthor &&
    applicationStateService.bookConfig.whiteboard) {
        <hr/>
    }
    <!--    <button *ngIf="applicationStateService.userData.isTeacher"-->
    <!--            class="sidebar-nav-button small-font-size"-->
    <!--            (click)="openComponentInSidebar(TestGeneratorComponent)"-->
    <!--            [url]="'sidebar/test-generator.png' | asset"-->
    <!--            [style.height.px]="'95'"-->
    <!--            [size]="'65%'"-->
    <!--            [position]="'center 15px'"-->
    <!--            [class.active]="sidebarService.activeComponent === TestGeneratorComponent"-->
    <!--            backgroundImage>-->
    <!--        <span>Test Generator</span>-->
    <!--    </button>-->
    <!--    <hr *ngIf="applicationStateService.userData.isTeacher"/>-->
    <!--    <button *ngIf="quicklinkService.digiTrainerContent$ | async" class="sidebar-nav-button"-->
    <!--            (click)="openDigiTrainer()"-->
    <!--            [url]="'sidebar/sidebar-icon-digitrainer.png' | asset"-->
    <!--            [style.height.px]="'95'"-->
    <!--            [size]="'70%'"-->
    <!--            [position]="'center 15px'"-->
    <!--            backgroundImage><span>Digi Trainer</span>-->
    <!--    </button>-->
    <!--    <hr *ngIf="quicklinkService.digiTrainerContent$ | async"/>-->
    <button (click)="openComponentInSidebar(NotesContentComponent)" [class.active]="sidebarService.activeComponent === NotesContentComponent"
            [position]="'center 15px'"
            [size]="'70%'"
            [style.height.px]="'95'"
            [url]="'sidebar/sidebar-icon-notizen.png' | asset"
            backgroundImage
            class="sidebar-nav-button"><span>Meine Notizen</span>
    </button>
    <!--
    Add this button when School Bag becomes available
    <hr/>
    <button class="sidebar-nav-button" (click)="openComponentInSidebar(NotesContentComponent)"
      [url]="'sidebar/sidebar-icon-dateien.png' | asset"
      [style.height.px]="'100'"
      [size]="'50%'"
      [position]="'center 15px'"
      backgroundImage><span>Meine Dateien</span>
    </button>
    -->
</div>
<div (wheel)="stopPropagation($event)"
     [class.expanded]="!applicationStateService.isSidebarHidden"
     [style.width.px]="sidebarConfig.sidebarCollapsed"
     [style.display]="!applicationStateService.isSidebarHidden ? 'block' : 'none'"
     id="bookviewerExpandedSidebarContainer">

    <div [hidden]="applicationStateService.isSidebarHidden" class="sidebar-content-wrapper">
        @if (!applicationStateService.isSidebarHidden) {
            <ng-container #childHost/>
        }
    </div>

    <button (click)="close()" id="sidebarCloseButton">SCHLIESSEN <i aria-hidden="true"
                                                                    class="fa fa-times fa-lg"></i></button>
</div>
